import { defineNuxtRouteMiddleware, useRequestEvent } from '#imports'

import { setMetricHttpRoute } from '@backmarket/instrument/setMetricHttpRoute'
import { updateActiveSpan } from '@backmarket/instrument/updateActiveSpan'
import { faro } from '@grafana/faro-web-sdk'

import { getRoutePath } from '../utils/getRoutePath'
/**
 * Per-route hook that updates downstream observability tooling with the
 * matched route name and metadata.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    const event = useRequestEvent()
    if (!event) return

    const path = getRoutePath(to)
    const resource = `${event.node.req.method} ${path}`

    setMetricHttpRoute(path)

    updateActiveSpan((span) => {
      span.setAttributes({
        // dd legacy
        'resource.name': resource,
        'resource.locale': to.params?.locale ?? 'unknown',
        // otel
        'http.route': path,
      })
    })

    return
  }

  if (process.client && faro?.api) {
    const path = getRoutePath(to)
    faro.api.setView({ name: path })
  }
})
